import { Home, Search, Map, Heart } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

const NAV_ITEMS = [
  { icon: Home, label: 'Home', to: '/' },
  { icon: Search, label: 'Search', to: '/search' },
  { icon: Map, label: 'Map', to: '/map' },
  { icon: Heart, label: 'Favorites', to: '/dashboard/favorites' },
];

export function MobileBottomNav() {
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-card/95 backdrop-blur-md border-t safe-area-bottom">
      <div className="grid grid-cols-4 h-14">
        {NAV_ITEMS.map(({ icon: Icon, label, to }) => {
          const isActive = to === '/' ? pathname === '/' : pathname.startsWith(to);
          return (
            <Link
              key={to}
              to={to}
              onClick={to === '/' ? () => window.scrollTo({ top: 0, behavior: 'smooth' }) : undefined}
              className={cn(
                'flex flex-col items-center justify-center gap-0.5 text-muted-foreground transition-colors',
                isActive && 'text-primary'
              )}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-medium">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
